define([], () => {

  const CLIENT_MODES = Object.freeze({
    ADMIN: 'admin',
    MANAGE: 'manage',
  });

  const SLUG_TO_APP = {
    integrations: {
      appId: '04e599f6-fa2d-498a-b560-64a2e0090e1f',
      name: 'SumoMe Pro',
    },
    listbuilder: {
      id: 'd54f52bc-ee3b-4e1a-95d1-f7fbdbccf7bc',
      appId: '156085c5-0017-4150-b225-a731ad248f38',
      name: 'List Builder Pro',
    },
    subscribers: {
      appId: 'subscribers',
      name: 'BDOW! Pro',
    },
    chat: {
      appId: 'def79cfc-384b-45dd-b6b0-71ee6639860d',
      name: 'Live Chat',
    },
  };

  const FEATURES = {
    AB_TESTING: 'abTesting',
    PRO_STATS: 'proStats',
    AUTOMATIC_EMAIL_RESPONDER: 'successAutomaticEmailResponder',
    REDIRECT_ON_SUBSCRIBE_SUCCESS: 'redirectOnSubscribeSuccess',
    ADD_SUBSCRIBER_SUCCESS_TO_GROUP: 'addSubscriberSuccessToGroup',
    AUTO_CLOSE_TIMER_ON_SUCCESS: 'autoCloseTimerOnSuccess',
    TRACKING_PIXELS: 'trackingPixels',
    LB_CLICK_TRIGGERS: 'lbClickTriggers',
    LB_COUNTDOWN_TIMER: 'lbCountdownTimer',
    INTEGRATIONS: 'integrations',
    ESP_AWEBER: 'espAweber',
    ESP_ZAPIER: 'espZapier',
    ESP_CONSTANTSCONTACT: 'espConstantcontact',
    ESP_CAMPAIGNMONITOR: 'espCampaignmonitor',
    ESP_GETRESPONSE: 'espGetresponse',
    ESP_ACTIVECAMPAIGN: 'espActivecampaign',
    ESP_EMMA: 'espEmma',
    ESP_MADMIMI: 'espMadmimi',
    ESP_FEEDBLITZ: 'espFeedblitz',
    ESP_MNB: 'espMnb',
    ESP_INBOXFIRST: 'espInboxfirst',
    ESP_KLAVIYO_OAUTH: 'espKlaviyoOauth',
    ESP_VERO: 'espVero',
    ESP_MAILCHIMP: 'espMailchimp',
    ESP_VERTICALRESPONSE: 'espVerticalresponse',
    ESP_DRIP: 'espDrip',
    ESP_MAILERLITE: 'espMailerlite',
    ESP_MAILERLITE_CONNECT: 'espMailerliteConnect',
    ESP_WHATCOUNTS: 'espWhatcounts',
    ESP_CONVERTKIT: 'espConvertkit',
    ESP_MAILJET: 'espMailjet',
    ESP_MAROPOST: 'espMaropost',
    ESP_MARKETO: 'espMarketo',
    ESP_MAILIGEN: 'espMailigen',
    ESP_FORMSYNC: 'espFormsync',
    ESP_SENDY: 'espSendy',
    ESP_BRITEVERIFY: 'espBriteverify',
    ESP_ITERABLE: 'espIterable',
    ESP_ICONTACT: 'espIcontact',
    ESP_INFUSIONSOFT: 'espInfusionsoft',
    ESP_HUBSPOT: 'espHubspot',
    ESP_SAILTHRU: 'espSailthru',
    ESP_PARDOT: 'espPardot',
    ESP_ONTRAPORT: 'espOntraport',
    ESP_SALESFORCE: 'espSalesforce',
    ESP_SENDFOX: 'espSendfox',
    ESP_FACEBOOK: 'espFacebook',
    ESP_FLODESK: 'espFlodesk',
    WEBHOOK: 'webhook',
    DISCOUNT_CODES_MULTIUSE: 'discountCodes:multiuse',
    DISCOUNT_CODES_UNIQUE: 'discountCodes:unique',
    PUSH_NOTIFICATIONS: 'pushNotifications',
    BUY_BUTTON: 'buyButton',
    NO_SUMO_BRANDING: 'noSumoBranding',
    PRO_DISPLAY_RULES: 'proDisplayRules',
    SMARTBAR: 'smartbar',
    WELCOMEMAT: 'welcomemat',
    HEATMAPS: 'heatmaps',
    IMAGE_SHARER: 'imageSharer',
    DISCOVER: 'discover',
    CONTACT_FORM: 'contactForm',
    SHARE: 'share',
    CONTENT_ANALYTICS: 'contentAnalytics',
    CONTENT_UPGRADES: 'contentUpgrades',
    PRO_TEMPLATES: 'proTemplates',
    LIVE_CHAT: 'liveChat',
    ECOMMERCE_TEMPLATES: 'ecommerceTemplates',
    SEASONAL_TEMPLATES: 'seasonalTemplates',
    CART_CASINO: 'cartCasino',
    SHORTCUTS_GROW_EMAIL_LIST: 'shortcuts:grow-email-list',
    SHORTCUTS_AVERAGE_ORDER_VALUE: 'shortcuts:average-order-value',
    SHORTCUT_CART_ABANDONMENT: 'shortcuts:cart-abandonment',
    SHORTCUT_CONVERT_WINDOW_SHOPPERS: 'shortcuts:product-view-email',
    SOCIAL_PROOF_BASE: 'socialProof:base',
    SOCIAL_PROOF_ECOMMERCE: 'socialProof:ecommerce',
    SOCIAL_PROOF_FREE: 'socialProof:free',
    SUPPORT_LIVE_CHAT: 'supportLiveChat',
    EVERGREEN_COUNTDOWN: 'evergreenCountdown',
    CUSTOM_CODE: 'featureCustomCode',
  };

  return {
    SLUG_TO_APP,
    FEATURES,
    CLIENT_MODES,
  };
});
